import { useTranslation } from 'react-i18next'
import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { MarkedAdLine } from '../MarkedAdLine'
import React from 'react'

interface LatestAdExampleCellProps {
  latest_ad: {
    title: string
    text: string
    url: string
    link_screen_url: string
    search_screen_url: string
    keyword: string
    search_engine: string
    ad_position: number
    last_found: string
    country: string
  }
}

export const LatestAdExampleCell = ({ latest_ad }: LatestAdExampleCellProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={
        'flex w-[260px] flex-col gap-[8px] rounded-[4px] border border-dashed border-[#E5E1EA] bg-white px-[8px] py-[4px]'
      }
    >
      <div>
        <MarkedAdLine className={'text-[15px] leading-[24px]'} html={latest_ad.title} />
        <MarkedAdLine
          className={'text-[14px] leading-[20px] text-[#8E7CA7]'}
          html={latest_ad.text}
        />
        <p
          className={'truncate break-all text-[14px] leading-[20px] text-[#258A00]'}
          dangerouslySetInnerHTML={{ __html: latest_ad.url }}
        />
      </div>
      <div>
        <p className={'text-[14px]'}>
          <span className={'text-[#8E7CA7]'}>{t('pages.trademarkInfringements.screenshots')}:</span>{' '}
          <BpAnchor
            className={'whitespace-nowrap'}
            href={latest_ad.search_screen_url}
            target='_blank'
          >
            {t('components.detailsCell.SERP')}
          </BpAnchor>
          ,{' '}
          <BpAnchor
            className={'whitespace-nowrap'}
            href={latest_ad.link_screen_url}
            target='_blank'
          >
            {t('components.detailsCell.landingPage')}
          </BpAnchor>
        </p>
      </div>
    </div>
  )
}
